import React from 'react';
import './index.css';
import clsx from 'classnames';
import { Loading, More } from 'components';
import { useHistory } from 'react-router-dom';
import { useNewsList } from 'hooks';

const News = () => {
  const history = useHistory();
  // 获取产品列表数据
  const { data, loading } = useNewsList(
    { pageNo: 1, pageSize: 3 },
    { immediate: true },
  );
  const newsList = data?.list;

  // 跳转至新闻详情
  const goDetail = (id) => {
    history.push(`/news/${id}`);
  };

  return (
    <div className={clsx('news')}>
      <div className={clsx('news-title')}>新闻中心</div>
      <div className={clsx('news-desc')}>查看之阳最新消息</div>
      {!loading ? (
        <div className={clsx('news-list')}>
          {newsList?.map((v, index) => {
            const { cover, title } = v;
            const imgUrl =
              'http://offical-php.zjzyfwq.com/uploads/' + cover[0]?.filename;
            return (
              <div
                className={clsx('news-item')}
                key={index}
                onClick={() => goDetail(v.id)}
              >
                <div className={clsx('news-item__block')}>
                  <img src={imgUrl} alt='' width={'100%'} height={'100%'} />
                </div>
                <div className={clsx('news-item__title')}>{title}</div>
                <button className={clsx('news-item__btn')}>
                  MORE
                  {/* 右箭头 */}
                  <svg
                    viewBox='64 64 896 896'
                    focusable='false'
                    data-icon='right'
                    fill='currentColor'
                    aria-hidden='true'
                    className={clsx('news-item__svg')}
                  >
                    <path d='M765.7 486.8L314.9 134.7A7.97 7.97 0 00302 141v77.3c0 4.9 2.3 9.6 6.1 12.6l360 281.1-360 281.1c-3.9 3-6.1 7.7-6.1 12.6V883c0 6.7 7.7 10.4 12.9 6.3l450.8-352.1a31.96 31.96 0 000-50.4z'></path>
                  </svg>
                </button>
              </div>
            );
          })}
        </div>
      ) : (
        <Loading />
      )}
      {/* 更多按钮 */}
      <More path='/news' style={{ margin: '9px 0 24px' }} />
    </div>
  );
};

export default News;
